import { render, staticRenderFns } from "./zDebugInfo.vue?vue&type=template&id=00488348&scoped=true&"
import script from "./zDebugInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./zDebugInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./zDebugInfo.vue?vue&type=style&index=0&id=00488348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00488348",
  null
  
)

export default component.exports